module.exports = __webpack_public_path__ + "img/img24.5267acb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img24.jpg
// module id = 321
// module chunks = 0